import { render, staticRenderFns } from "./ExcBlockHeadingRow.vue?vue&type=template&id=144813c0&scoped=true&"
import script from "./ExcBlockHeadingRow.vue?vue&type=script&lang=ts&"
export * from "./ExcBlockHeadingRow.vue?vue&type=script&lang=ts&"
import style0 from "./ExcBlockHeadingRow.vue?vue&type=style&index=0&id=144813c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144813c0",
  null
  
)

export default component.exports